<template>
    <v-dialog v-model="isOpen" persistent max-width="400px">
        <v-card>
            <v-card-title class="headline">4자리 비밀번호 입력</v-card-title>

            <v-card-text>
                <v-text-field
                    v-model="pin"
                    type="password"
                    maxlength="4"
                    label="비밀번호 입력"
                    variant="outlined"
                ></v-text-field>
                <p v-if="errorMessage" class="error-text">{{ errorMessage }}</p>
            </v-card-text>

            <v-card-actions class="d-flex justify-end">
                <v-btn color="grey" @click="closeModal">취소</v-btn>
                <v-btn color="primary" @click="verifyPin">확인</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { ref, defineExpose } from "vue";
import { useStore } from "vuex";

export default {
    props: {
        targetId: {
            type: Number,
            default: 0,
        },
        // 0: afterservice, 1: lecture
        target: {
            type: Number,
            default: 0,
        },
    },
    setup(props, { emit }) {
        const store = useStore();
        const isOpen = ref(false);
        const pin = ref("");
        const errorMessage = ref("");

        // 모달 열기
        const openModal = () => {
            isOpen.value = true;
            pin.value = "";
            errorMessage.value = "";
        };

        // 모달 닫기
        const closeModal = () => {
            isOpen.value = false;
        };

        // PIN 검증 로직
        const verifyPin = async () => {
            let isAuth = false;
            let isError = false;
            if (props.target === 0) {
                isAuth = await store
                    .dispatch("verifyPin", {
                        pin: pin.value,
                        afterserviceId: props.targetId,
                    })
                    .catch((err) => {
                        console.log("verify err: ", err);
                        isError = true;
                        errorMessage.value = err;
                    });
            } else if (props.target === 1) {
                isAuth = await store.dispatch("verifyPinLecture", {
                    pin: pin.value,
                        lectureId: props.targetId,
                }).catch((err) => {
                        console.log("verify err: ", err);
                        isError = true;
                        errorMessage.value = err;
                    });
            }
            if (isAuth) {
                emit("pinVerified", true); // 부모 컴포넌트로 성공 이벤트 전달
                closeModal();
            } else if (!isError) {
                errorMessage.value = "비밀번호가 올바르지 않습니다.";
            }
        };

        defineExpose({ openModal, closeModal });

        return {
            isOpen,
            pin,
            errorMessage,
            openModal,
            closeModal,
            verifyPin,
        };
    },
};
</script>

<style scoped>
.error-text {
    color: red;
    font-size: 14px;
}
</style>
